import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { usePathname, useSearchParams } from 'next/navigation';

import styles from './link.module.scss';
import { LinkPropTypes } from '../prop-types';

const FilterLink = ({ filter, queryParams = {} }) => {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const createQueryString = useCallback(
    (name, value) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);
      return params.toString();
    },
    [searchParams]
  );

  const handleChange = () => {
    if (filter?.param && filter?.paramValue) {
      window.history.pushState(
        {},
        '',
        `${pathname}?${createQueryString(filter.param, filter.paramValue)}`
      );
    }
  };

  return (
    <div
      className={classNames(styles['filter-link'], {
        [styles['filter-link-active']]:
          queryParams[filter.param] === filter.paramValue ||
          (!filter.paramValue && !queryParams[filter.param]),
      })}
      aria-hidden="true"
      onClick={handleChange}
      onKeyDown={handleChange}
      onKeyUp={handleChange}
      onKeyPress={handleChange}
    >
      {filter.label}
    </div>
  );
};

FilterLink.propTypes = {
  filter: LinkPropTypes,
  queryParams: PropTypes.object,
};

export default FilterLink;
